"use strict";
class DeveloperSettingsController {

    constructor($scope, $window, SSHttpService, SSUtilService, SSAlertService, SSUserService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;

        self.BASE_URL = $window.location.pathname;

        self.data = SHOWSUITE.data;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;
    }

    save() {
        const self = this;

        var params = {
            user_email_alerts: parseInt(self.data.user.email_alerts),
            user_mobile_notifications: parseInt(self.data.user.mobile_notifications),
        };

        var url = `${self.BASE_URL}/users/me/notifications`;

        loading(true);
        self.SSHttpService.putRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.code == 401) {
                    self.SSAlertService.danger("Oops!", "Your session has expired. Please re-login to continue.");
                } else if (response.code == 500) {
                    self.SSAlertService.danger("Oops!", "Something went wrong. Please contact support.");
                }
                return;
            }

            self.SSAlertService.success("Settings updated successfully.");
        });
    }

}

DeveloperSettingsController.$inject = [
    '$scope',
    '$window',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSUserService',
];
app.controller('DeveloperSettingsController', DeveloperSettingsController);
